import { useQuery } from "@tanstack/react-query";
import type {
  MatrixCell,
  MatrixMonth,
  MatrixRow,
  ResourceGuidanceMatrix,
} from "@/api/resource-guidance-matrix";
import { jsonFetch } from "@/lib/json-fetch";
import { guidanceKeys } from "@/lib/query";

export type { MatrixCell, MatrixMonth, MatrixRow, ResourceGuidanceMatrix };

/**
 * One Resource's Solutions × months guidance/actuals matrix, for the drawer
 * drill-down. `enabled` is the modal's open state — the matrix pulls every linked
 * demand's guidance from NOS, so it must not fetch until the user actually opens it.
 */
export function useResourceGuidanceMatrix(
  resourceId: string,
  enabled: boolean,
): {
  data: ResourceGuidanceMatrix | undefined;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  refetch: () => void;
} {
  const { data, isLoading, isError, error, refetch } = useQuery<ResourceGuidanceMatrix>({
    queryKey: guidanceKeys.matrix(resourceId),
    queryFn: () =>
      jsonFetch<ResourceGuidanceMatrix>(`/api/dashboard/resources/${resourceId}/guidance-matrix`),
    enabled,
    staleTime: 5 * 60 * 1000,
  });
  return { data, isLoading, isError, error: error ?? null, refetch: () => void refetch() };
}
